import './App.css';
import {Calculator} from './Calculator.jsx'

export const App = () => {
  return (
    <div className="App">
        <Calculator />
    </div>
  );
}
